import TermsPage from "./TermsPage";

export default function PrivacyPolicyPage() {
  return (
    <TermsPage
      heading="Privacy Policy"
      documentTitle="Privacy Policy | FastSearch"
    />
  );
}
